import { render, staticRenderFns } from "./RealMonitorMgr.vue?vue&type=template&id=c4015c18&scoped=true"
import script from "./RealMonitorMgr.vue?vue&type=script&lang=js"
export * from "./RealMonitorMgr.vue?vue&type=script&lang=js"
import style0 from "./RealMonitorMgr.vue?vue&type=style&index=0&id=c4015c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4015c18",
  null
  
)

export default component.exports